import { useUpcomingCalendarEvents } from "@mirage/service-calendar-events/hooks";
import { transformDashResultToMirage } from "@mirage/service-dbx-api/service/utils";
import type { SearchResult } from "@mirage/shared/search/search-result";
import { isNotNull } from "@mirage/shared/util/tiny-utils";
import { useMemo } from "react";

// NOTE: max events we display is now determined at the source level
// Longer-term: we should move this to the service layer completely instead
// of passing these events into every performSearch function
const MAX_EVENTS_SET_TO_SCORE = 10;

export const useCalendarEventsForTypeahead = (): SearchResult[] => {
  const { upcomingCalendarEvents } = useUpcomingCalendarEvents();

  return useMemo(() => {
    return (upcomingCalendarEvents ?? [])
      .map((e) => transformDashResultToMirage(e))
      .filter(isNotNull)
      .filter((e) => !e.isAllDay)
      .slice(0, MAX_EVENTS_SET_TO_SCORE);
  }, [upcomingCalendarEvents]);
};
